function noOp(working, command, p) {
  return working.text;
}
noOp.key = "no-op";
noOp.title = "No Operation";
noOp.category = "Flow Control";
noOp.docUrl = "https://deanebarker.net/tech/code/textflow-js/commands/no-op/";
noOp.description =
  "A command that does nothing and returns the working data unchanged.";
noOp.args = [];
noOp.passthrough = true;

export default noOp;
